import { render, staticRenderFns } from "./salon_home.vue?vue&type=template&id=865c880c&scoped=true"
import script from "./salon_home.vue?vue&type=script&lang=js"
export * from "./salon_home.vue?vue&type=script&lang=js"
import style0 from "./salon_home.vue?vue&type=style&index=0&id=865c880c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865c880c",
  null
  
)

export default component.exports